module.exports = __webpack_public_path__ + "img/li-circle-ok.f2fe7349.svg";